import React from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import { connect } from 'react-redux';
import ENUMS from '../../../enums';
import { formatter, domManipulator } from '../../../utils';
import { enumHelper } from '../../../utils';
import Spin from '../../../components/loading';
import * as discountCodesActions from '../../../redux/discountCodes/actions';
import * as messageActions from '../../../redux/messages/actions';
import AutoComplete from '../../../components/autoComplete';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import './sendMessage.scss';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class SendMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageTitle: '',
      messageBody: '',
      expirationTime: '',
      specialUsers: [],
      selectedUsersInfo: [],
      isSearched: false,
      minOrderInReservationValue: '',
      minSuccessfulReservationValue: '',
      specialUserIds: [],

      receiverTypesToUseCode: '',
      receiverTypesToUseCodeInvalidMessage: '',
      receiverTypesToUseCodeValidateStatus: '',

      showSpecialUsersDropDownFlag: false,
      receiver: '',
      messageReceiverError: false,
      messageTitleInputValidateStatus: '',
      messageTitleInputInvalidMessage: '',

      messageBodyInputValidateStatus: '',
      messageBodyInputInvalidMessage: '',

      expirationTimeInputValidateStatus: '',
      expirationTimeInputInvalidMessage: '',

      receiverUsersInputInvalidMessage: '',
      messageTimeError: false,
      messageDateError: false,
      receiverInputValidateStatus: '',

      expiredAtJalaali: ' ',
      expiredAtJalaaliInputValidateStatus: ' ',
      expiredAtJalaaliInputInvalidMessage: ' ',

      minOrderInReservationValueInputValidateStatus: '',
      minOrderInReservationValueInputInvalidMessage: '',

      minSuccessfulReservationValueInputValidateStatus: '',
      minSuccessfulReservationValueInputInvalidMessage: '',

      permittedUsersInputValidateStatus: '',
      permittedUsersInputInvalidMessage: '',

      minOrderAmountInputValidateStatus: '',
      minOrderAmountInputInvalidMessage: '',

      discountCodeInputValidateStatus: '',
      discountCodeInputInvalidMessage: '',

      specialUserIdsInputValidateStatus: '',
      specialUserIdsInputInvalidMessage: '',
    };
  }

  formRef = React.createRef();

  submitForm = isPublished => {
    let expiredAtJalaali = '',
      expirationTime = '',
      messageTitle = '',
      messageBody = '';
    let {
      messageReceiverError,
      discountCode,
      specialUserIds,
      receiverTypesToUseCode,
      minOrderInReservationValue,
      minSuccessfulReservationValue,
    } = this.state;

    let errors = {},
      firstErrorElementId = '',
      isMessageTitleValid,
      isMessageBodyValid,
      isExpirationTimeValid,
      isReceiverTypesToUseCodeValid,
      isMinSuccessfulReservationValueValid,
      isMinOrderInReservationValueValid,
      isDiscountCodeValid,
      isSpecialUserIdsValid,
      isExpiredAtJalaaliValid;

    Array.from(this.formRef.current).forEach(ele => {
      if (ele.value && ele.value.length)
        switch (ele.name) {
          case 'expiredAtJalaali': {
            expiredAtJalaali = formatter.toStandard(ele.value);
            break;
          }
          case 'expirationTime': {
            expirationTime = ele.value;
            break;
          }
          case 'messageBody': {
            messageBody = formatter.toStandard(ele.value);
            break;
          }
          case 'messageTitle': {
            messageTitle = formatter.toStandard(ele.value);
            break;
          }
        }
    });

    // validate form

    // title
    if (!messageTitle) {
      errors.messageTitleInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('titles.messageTitle'),
      });
      errors.messageTitleInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'messageTitle';
      isMessageTitleValid = false;
    } else {
      errors.messageTitleInputInvalidMessage = '';
      errors.messageTitleInputValidateStatus = '';
      isMessageTitleValid = true;
    }

    // body
    if (!messageBody) {
      errors.messageBodyInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.body'),
      });
      errors.messageBodyInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'messageBody';
      isMessageBodyValid = false;
    } else {
      errors.messageBodyInputInvalidMessage = '';
      errors.messageBodyInputValidateStatus = '';
      isMessageBodyValid = true;
    }

    if (!expirationTime) {
      errors.expirationTimeInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.time'),
      });
      errors.expirationTimeInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'expirationTime';
      isExpirationTimeValid = false;
    } else {
      errors.expirationTimeInputInvalidMessage = '';
      errors.expirationTimeInputValidateStatus = '';
      isExpirationTimeValid = true;
    }

    // expired at
    if (!this.state.expiredAtJalaali) {
      errors.expiredAtJalaaliInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('fields.expiredAtJalaali'),
      });
      errors.expiredAtJalaaliInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'expiredAtJalaali';
      isExpiredAtJalaaliValid = false;
    } else {
      errors.expiredAtJalaaliInputInvalidMessage = '';
      errors.expiredAtJalaaliInputValidateStatus = '';
      isExpiredAtJalaaliValid = true;
    }

    // receiver type to use code
    if (!receiverTypesToUseCode) {
      errors.receiverTypesToUseCodeInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('labels.receiver'),
      });
      errors.receiverTypesToUseCodeValidateStatus = 'is-invalid';
      firstErrorElementId = 'receiverTypesToUseCode';
      isReceiverTypesToUseCodeValid = false;
    } else {
      errors.receiverTypesToUseCodeInvalidMessage = '';
      errors.receiverTypesToUseCodeValidateStatus = '';
      isReceiverTypesToUseCodeValid = true;
    }

    if (
      !!receiverTypesToUseCode &&
      receiverTypesToUseCode.value == ENUMS.MESSAGE_RECEIVERS.values.SPECIAL_USERS &&
      !specialUserIds.length
    ) {
      errors.specialUserIdsInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.specialUsers'),
      });
      errors.specialUserIdsInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'specialUserIds';
      isSpecialUserIdsValid = false;
    } else {
      errors.specialUserIdsInputInvalidMessage = '';
      errors.specialUserIdsInputValidateStatus = '';
      isSpecialUserIdsValid = true;
    }

    if (
      !!receiverTypesToUseCode &&
      receiverTypesToUseCode.value == ENUMS.MESSAGE_RECEIVERS.values.HAS_MIN_SUCCESSFUL_RESERVATION &&
      !minSuccessfulReservationValue
    ) {
      errors.minSuccessfulReservationValueInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.minSuccessfulReservationValue'),
      });
      errors.minSuccessfulReservationValueInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'minSuccessfulReservationValue';
      isMinSuccessfulReservationValueValid = false;
    } else {
      errors.minSuccessfulReservationValueInputInvalidMessage = '';
      errors.minSuccessfulReservationValueInputValidateStatus = '';
      isMinSuccessfulReservationValueValid = true;
    }

    if (
      !!receiverTypesToUseCode &&
      receiverTypesToUseCode.value == ENUMS.MESSAGE_RECEIVERS.values.DISCOUNT_CODE_USERS &&
      !discountCode
    ) {
      errors.discountCodeInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.discountCode'),
      });
      errors.discountCodeInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'discountCode';
      isDiscountCodeValid = false;
    } else {
      errors.discountCodeInputInvalidMessage = '';
      errors.discountCodeInputValidateStatus = '';
      isDiscountCodeValid = true;
    }

    if (
      !!receiverTypesToUseCode &&
      receiverTypesToUseCode.value == ENUMS.MESSAGE_RECEIVERS.values.HAS_MIN_ORDER_IN_RESERVATION &&
      !minOrderInReservationValue
    ) {
      errors.minOrderInReservationValueInputInvalidMessage = locales('messages.fieldValueIsRequired', {
        fieldName: locales('tables.minOrderInReservation'),
      });
      errors.minOrderInReservationValueInputValidateStatus = 'is-invalid';
      firstErrorElementId = 'minOrderInReservationValue';
      isMinOrderInReservationValueValid = false;
    } else {
      errors.minOrderInReservationValueInputInvalidMessage = '';
      errors.minOrderInReservationValueInputValidateStatus = '';
      isMinOrderInReservationValueValid = true;
    }

    let isFormValid =
      isMessageTitleValid &&
      isMessageBodyValid &&
      isExpirationTimeValid &&
      isSpecialUserIdsValid &&
      isDiscountCodeValid &&
      isMinOrderInReservationValueValid &&
      isMinSuccessfulReservationValueValid &&
      isExpiredAtJalaaliValid &&
      isReceiverTypesToUseCodeValid;

    if (!isFormValid) {
      return this.setState(
        () => ({
          ...errors,
        }),
        () => {
          domManipulator.scrollIntoView(firstErrorElementId);
        },
      );
    }
    if (!messageReceiverError && isFormValid) {
      let expiration = JSON.parse(
        `${expiredAtJalaali && expiredAtJalaali.split('/').join('')}${expirationTime &&
        expirationTime.split(':').join('')}`,
      );
      this.props
        .sendMessage(
          messageTitle,
          messageBody,
          isPublished,
          `${expiration}`,
          specialUserIds,
          receiverTypesToUseCode.value,
          minOrderInReservationValue,
          minSuccessfulReservationValue,
          typeof discountCode == 'object' ? discountCode.value : discountCode,
        )
        .then(() => {
          this.props.history.push('/messages');
          AlertAndConfirmation({
            title: locales('titles.insertedSuccessfully'),
            text: '',
            type: 'success',
          });
        });
    }
  };

  componentDidMount() {
    this.props.fetchAllDiscountCodes();
  }

  clearForm = event => {
    if (event) {
      event.preventDefault();
    }

    const states = Object.keys(this.state);

    return Array.from(this.formRef.current).forEach(ele => {
      ele.value = ' ';

      if (states.some(key => key === ele.name)) {
        this.setState({ [ele.name]: ' ' });
      }
    });
  };

  setMessageTitle = event => {
    this.setState({
      messageTitle: event.target.value,
      messageTitleInputValidateStatus: '',
      messageTitleInputInvalidMessage: '',
    });
  };

  setMessageBody = event => {
    this.setState({
      messageBody: event.target.value,
      messageBodyInputValidateStatus: '',
      messageBodyInputInvalidMessage: '',
    });
  };

  setExpiredAtJalaali = val => {
    this.setState({
      expiredAtJalaali: val,
      expiredAtJalaaliInputValidateStatus: '',
      expiredAtJalaaliInputInvalidMessage: '',
    });
  };

  setExpirationTime = event => {
    this.setState({
      expirationTime: event.target.value,
      expirationTimeInputValidateStatus: '',
      expirationTimeInputInvalidMessage: '',
    });
  };

  setMinOrderInReservationValue = event => {
    let { value } = event.target;
    this.setState({
      minOrderInReservationValue: value,
      minOrderInReservationValueInputValidateStatus: '',
      minOrderInReservationValueInputInvalidMessage: '',
    });
  };

  setMinSuccessfulReservationValue = event => {
    let { value } = event.target;
    this.setState({
      minSuccessfulReservationValue: value,
      minSuccessfulReservationValueInputValidateStatus: '',
      minSuccessfulReservationValueInputInvalidMessage: '',
    });
  };

  setReceiverTypesToUseCode = item => {
    this.setState({
      receiverTypesToUseCode: { ...item },
      receiverTypesToUseCodeValidateStatus: '',
      receiverTypesToUseCodeInvalidMessage: '',
    });
  };

  setDiscountCode = item => {
    this.setState({
      discountCode: { ...item },
      discountCodeValidateStatus: '',
      discountCodeInvalidMessage: '',
    });
  };

  renderPermittedUsersInput = () => {
    let {
      searchText,
      isSearched,
      discountCode,
      receiverTypesToUseCode,

      specialUser,
      minSuccessfulReservationValue,
      minOrderInReservationValue,

      specialUsers,

      minOrderInReservationValueInputValidateStatus,
      minOrderInReservationValueInputInvalidMessage,

      minSuccessfulReservationValueInputValidateStatus,
      minSuccessfulReservationValueInputInvalidMessage,

      specialUserIdsInputValidateStatus,
      specialUserIdsInputInvalidMessage,

      discountCodeInputInvalidMessage,
      discountCodeInputValidateStatus,
    } = this.state;

    let { editMode, discountCodesList, searchedSpecialUsersList = [] } = this.props;
    let {
      HAS_MIN_ORDER_IN_RESERVATION,
      HAS_MIN_SUCCESSFUL_RESERVATION,
      SPECIAL_USERS,
      DISCOUNT_CODE_USERS,
    } = ENUMS.MESSAGE_RECEIVERS.values;

    switch (typeof receiverTypesToUseCode == 'object' ? receiverTypesToUseCode.value : specialUser) {
      case HAS_MIN_SUCCESSFUL_RESERVATION: {
        return (
          <>
            <label className="rsee-form-label " htmlFor="minSuccessfulReservationValue">
              {locales('tables.count')}
            </label>
            <div className="">
              <input
                id="minSuccessfulReservationValue"
                name="minSuccessfulReservationValue"
                type="text"
                className={`form-control ${minSuccessfulReservationValueInputValidateStatus}`}
                onChange={this.setMinSuccessfulReservationValue}
                autoComplete="off"
                value={minSuccessfulReservationValue}
              />
              <div className="invalid-feedback">{minSuccessfulReservationValueInputInvalidMessage}</div>
            </div>
          </>
        );
      }

      case DISCOUNT_CODE_USERS: {
        return (
          <>
            <label className="rsee-form-label " htmlFor="discountCode">
              {locales('tables.discountCode')}
            </label>
            <div className="w-100">
              <Select
                placeholder={
                  discountCode && discountCode.length ? discountCode : locales('labels.selectDiscountCode')
                }
                isMulti={false}
                className={`rc-dropdown ${!!discountCodeInputValidateStatus ? 'is-invalid' : ''}`}
                name="discountCode"
                onChange={this.setDiscountCode}
                value={discountCode}
                options={discountCodesList.map(item => ({
                  label: item.title,
                  value: item.id,
                }))}
              />
              <div className="invalid-feedback">{discountCodeInputInvalidMessage}</div>
            </div>
          </>
        );
      }

      case HAS_MIN_ORDER_IN_RESERVATION: {
        return (
          <>
            <label className="rsee-form-label " htmlFor="minOrderInReservationValue">
              {locales('tables.mintotalReservePrice')}
            </label>
            <div className="">
              <input
                id="minOrderInReservationValue"
                name="minOrderInReservationValue"
                type="text"
                className={`form-control ${minOrderInReservationValueInputValidateStatus}`}
                onChange={this.setMinOrderInReservationValue}
                autoComplete="off"
                value={minOrderInReservationValue}
              />
              <div className="invalid-feedback">{minOrderInReservationValueInputInvalidMessage}</div>
            </div>
          </>
        );
      }

      case SPECIAL_USERS: {
        return (
          <>
            <label className="rsee-form-label text-left" htmlFor="specialUserIds">
              {locales('titles.users')}
            </label>
            <AutoComplete
              id="specialUserIds"
              errorText={specialUserIdsInputInvalidMessage}
              name="specialUserIds"
              searchInputClassName={`col-12`}
              inputErrorClassName={`${specialUserIdsInputValidateStatus}`}
              containerClassName="d-flex flex-wrap col"
              searchedList={searchedSpecialUsersList}
              defaultList={specialUsers}
              onSearchInputChanged={this.onSearchInputChanged}
              onSearchComplete={this.handleAutoCompleteDone}
            />
            <div className="invalid-feedback">{minOrderInReservationValueInputInvalidMessage}</div>
          </>
        );
      }
      default:
        break;
    }
  };

  // setReceiver = item => {
  //   if (item.value == ENUMS.MESSAGE_RECEIVERS.value.SPECIAL_USERS) {
  //     this.setState({ showReceiverTypesDropDownFlag: true })
  //   }
  //   else {
  //     this.setState({ showReceiverTypesDropDownFlag: false })
  //   }
  //   this.setState({ receiver: item })

  // };

  onSearchInputChanged = searchKey => {
    this.props.fetchSearchedSpecialUsers ? this.props.fetchSearchedSpecialUsers(`filter=(textPart~contains~${searchKey})`)
      : this.props.actions.fetchSearchedSpecialUsers(`filter=(textPart~contains~${searchKey})`);
  };

  handleAutoCompleteDone = selectedIds => {
    this.setState({
      specialUserIds: selectedIds,
      specialUserIdsInputValidateStatus: '',
      specialUserIdsInputInvalidMessage: '',
    });
  };

  render() {
    const {
      discountCodesLoading,
      discountCodesMessage,
      discountCodesFailed,
      discountCodesError,
      sendMessageLoading,
      sendMessageFailed,
      sendMessageError,
      sendMessageMessage,
      searchedSpecialUsersLoading,
      searchedSpecialUsersMessage,
      searchedSpecialUsersFailed,
      searchedSpecialUsersError,
    } = this.props;

    let {
      messageTitleInputValidateStatus,
      messageTitleInputInvalidMessage,

      messageBodyInputValidateStatus,
      messageBodyInputInvalidMessage,

      expirationTimeInputValidateStatus,
      expirationTimeInputInvalidMessage,

      messageReceiverError,

      showReceiverTypesDropDownFlag,
      receiver,
      receiverTypesToUseCodeInvalidMessage,
      receiverTypesToUseCodeValidateStatus,

      receiverTypesToUseCode,

      receiverUsersInputInvalidMessage,
      messageDateError,
      messageTimeError,
      receiverInputValidateStatus,

      expiredAtJalaaliInputValidateStatus,
      expiredAtJalaaliInputInvalidMessage,
    } = this.state;

    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">{locales('titles.createNewMessage')}</h3>
          <div>
            <button onClick={() => this.submitForm(false)} className="btn btn-success w-5 mx-1">
              <i className="fa fa-save"/>
              {locales('labels.save')}
            </button>
            <button onClick={() => this.submitForm(true)} className="btn btn-primary w-5 mx-1">
              <i className="fal fa-upload mx-1"/>
              {locales('labels.saveAndPublish')}
            </button>
            <button onClick={() => this.props.history.push('/messages')} className="btn btn-default w-5 mx-1">
              <i className="fa fa-reply"/>
              {locales('labels.cancel')}
            </button>
          </div>
        </div>

        <Spin spinning={discountCodesLoading || searchedSpecialUsersLoading || sendMessageLoading}>
          {(discountCodesError || searchedSpecialUsersError || sendMessageError) && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {(discountCodesFailed || sendMessageFailed || searchedSpecialUsersFailed) && (
            <div className="alert alert-danger">
              {discountCodesMessage || searchedSpecialUsersMessage || sendMessageMessage}
            </div>
          )}

          <main className="panel panel-default">
            <div className="panel-heading">
              <i className="fas fa-list-alt px-1"/>
              {locales('titles.sendNewMessage')}
            </div>
            <div className="panel-body">
              <form ref={this.formRef} className="col-12 p-0">
                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('titles.messageTitle')}
                    </label>
                    <div className="full-width">
                      <input
                        id="messageTitle"
                        name="messageTitle"
                        className={`form-control ${messageTitleInputValidateStatus}`}
                        onChange={this.setMessageTitle}
                        placeholder={locales('titles.messageTitle')}
                      />

                      <div className="invalid-feedback">{messageTitleInputInvalidMessage}</div>
                    </div>
                  </div>
                </div>

                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('tables.body')}
                    </label>
                    <div className="full-width">
                      <textarea
                        id="messageBody"
                        name="messageBody"
                        className={`form-control ${messageBodyInputValidateStatus}`}
                        onChange={this.setMessageBody}
                        placeholder={locales('tables.body')}
                      ></textarea>
                      <div className="invalid-feedback">{messageBodyInputInvalidMessage}</div>
                    </div>
                  </div>
                </div>

                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('tables.expiredAtJalaali')}
                    </label>
                    <div className="full-width">
                      <DatePicker
                        marge={true}
                        placeholder="تاریخ انقضا"
                        id="expiredAtJalaali"
                        onChange={val => this.setExpiredAtJalaali(val)}
                        name="expiredAtJalaali"
                        className={`form-control start ${expiredAtJalaaliInputValidateStatus}`}
                        value={this.state.expiredAtJalaali}
                      />

                      <div
                        className={`invalid-feedback ${
                          !!expiredAtJalaaliInputInvalidMessage ? 'is-invalid-feedback' : ''
                        }`}
                      >
                        {expiredAtJalaaliInputInvalidMessage}
                      </div>
                    </div>
                  </div>
                </div>
                {/*
              <div className="form-group col d-flex required align-items-center">
                <label className="rsee-form-label" htmlFor="title">
                  {locales("labels.receiver")}
                </label>
                <div className='full-width'>
                  <Select
                    placeholder={locales('labels.chooseUsers')}
                    isMulti={false}
                    className={`rc-dropdown ${!!receiverInputValidateStatus ? 'is-invalid' : ''}`}
                    name="receiverTypesToUseCode"
                    onChange={this.setReceiver}
                    value={receiver}
                    options={ENUMS.MESSAGE_RECEIVERS.list.map(item => ({
                      label: item.title,
                      value: item.value
                    }))}
                  />
                  <div className="invalid-feedback">
                    {receiverUsersInputInvalidMessage}
                  </div>

                </div>
              </div> */}

                <div className="full-width my-3">
                  {
                    <div className="form-group col d-flex required align-items-center">
                      <label className="rsee-form-label text-right half-width" htmlFor="title">
                        {locales('labels.selectReceivers')}
                      </label>
                      <div className="full-width">
                        <Select
                          placeholder={
                            receiverTypesToUseCode && receiverTypesToUseCode.length
                              ? enumHelper.convertEnumValueToTitle(
                              ENUMS.MESSAGE_RECEIVERS.list,
                              receiverTypesToUseCode,
                              )
                              : locales('labels.chooseUsers')
                          }
                          isMulti={false}
                          className={`rc-dropdown ${this.state.receiverTypesToUseCodeValidateStatus}`}
                          id="receiverTypesToUseCode"
                          name="receiverTypesToUseCode"
                          onChange={this.setReceiverTypesToUseCode}
                          value={receiverTypesToUseCode}
                          options={[...ENUMS.MESSAGE_RECEIVERS.list].map(item => ({
                            label: item.title,
                            value: item.value,
                          }))}
                        />
                        <div className="invalid-feedback">{receiverTypesToUseCodeInvalidMessage}</div>
                      </div>

                      <div className="form-group col-6 d-flex required align-items-center justify-content-start">
                        {!!receiverTypesToUseCode && this.renderPermittedUsersInput()}
                      </div>
                    </div>
                  }
                </div>

                <div className="full-width my-3">
                  <div className="form-group col d-flex required align-items-center p-0 half-width">
                    <label className="rsee-form-label text-right half-width px-3" htmlFor="title">
                      {locales('tables.time')}
                    </label>
                    <div className="full-width">
                      <input
                        id="expirationTime"
                        name="expirationTime"
                        className={`form-control ${expirationTimeInputValidateStatus}`}
                        type="time"
                        onChange={this.setExpirationTime}
                      />
                      <div className="invalid-feedback">{expirationTimeInputInvalidMessage}</div>
                    </div>
                  </div>
                </div>
                {/* <div className='col-12 d-flex'>
                <label className='mx-2 d-flex justify-content-start p align-items-center' htmlFor="time">
                  {locales('tables.time')}:
                </label>
                <input
                  name='expirationTime'
                  className='col-2 form-control d-flex align-items-center justify-content-center'
                  id="time"
                  type='time'
                />
              </div> */}
                <div className="col-12 d-flex justify-content-end my-2">
                  <button className="btn btn-info" onClick={event => this.clearForm(event)}>
                    {locales('labels.clearForm')}
                  </button>
                </div>
              </form>
            </div>
          </main>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchedSpecialUsersLoading: state.discountCodesReducer.searchedSpecialUsersLoading,
    searchedSpecialUsersFailed: state.discountCodesReducer.searchedSpecialUsersFailed,
    searchedSpecialUsersError: state.discountCodesReducer.searchedSpecialUsersError,
    searchedSpecialUsersMessage: state.discountCodesReducer.searchedSpecialUsersMessage,
    searchedSpecialUsers: state.discountCodesReducer.searchedSpecialUsers,
    searchedSpecialUsersList: state.discountCodesReducer.searchedSpecialUsersList,

    discountCodesLoading: state.messagesReducer.discountCodesLoading,
    discountCodesFailed: state.messagesReducer.discountCodesFailed,
    discountCodesError: state.messagesReducer.discountCodesError,
    discountCodesMessage: state.messagesReducer.discountCodesMessage,
    discountCodes: state.messagesReducer.discountsCode,
    discountCodesList: state.messagesReducer.discountCodesList,

    sendMessageLoading: state.messagesReducer.sendMessageLoading,
    sendMessageFailed: state.messagesReducer.sendMessageFailed,
    sendMessageError: state.messagesReducer.sendMessageError,
    sendMessageMessage: state.messagesReducer.sendMessageMessage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllDiscountCodes: _ => dispatch(messageActions.fetchAllDiscountCodes()),
    fetchSearchedSpecialUsers: search => dispatch(discountCodesActions.fetchSearchedSpecialUsers(search)),
    sendMessage: (
      messageTitle,
      messageBody,
      isPublished,
      expiration,
      specialUserIds,
      receiverTypesToUseCode,
      minOrderInReservationValue,
      minSuccessfulReservationValue,
      discountCode,
    ) =>
      dispatch(
        messageActions.sendMessage(
          messageTitle,
          messageBody,
          isPublished,
          expiration,
          specialUserIds,
          receiverTypesToUseCode,
          minOrderInReservationValue,
          minSuccessfulReservationValue,
          discountCode,
        ),
      ),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SendMessage));
